<template>
  <div class="error-box" role="alert" aria-live="assertive">
    <div class="error-box-content">
      <img src="@Shared/assets/images/warning.svg" alt="warning" />
      <div class="error-box-text">
        <span class="header">{{boxTitle}}</span>
        <ul v-if="isList">
          <li v-for="error in errors">{{ error }}</li>
        </ul>
        <div v-else class="error-box_string">{{errors}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorBox",
  props: {
    title: {
      type: String,
      default: "Errors"
    },
    errors: {
      type: [Array, String]
    }
  },
  computed: {
    isList() {
      if (typeof this.errors === 'object' && this.errors instanceof Array) {
        return true;
      }
      return false;
    },
    boxTitle() {
      if (this.errors.length === 1){
        return "Error";
      } else {
        return this.title;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.error-box {
  border-left: 5px solid $color_red;
  margin-bottom: 30px;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);

  .error-box-content {
    border: 1px solid #d3d6de;
    border-left: 0;
    padding: 15px 35px;
    font-size: 14px;
    line-height: 22px;
    color: $color_stephs-grey;
    width: 100%;

    img {
      height: 21px;
      vertical-align: top;
    }

    .error-box-text {
      display: inline;
      margin-left: 10px;
      text-align: left;
    }

    .header {
      font-weight: bold;
      color: $color_red;
    }

    ul {
      line-height: 26px;
      padding-top: 3px;
    }

    li::before {
      content: "\2022";
      margin-right: 10px;
    }
    li {
      @media(max-width: $grid-breakpoint-md){
        display: flex;
      }
    }

    .error-box_string {
      padding-top: 3px;
      margin-left: 32px;
      text-align: left;
    }
  }
}
</style>
